
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/webinar/ai-security",
      function () {
        return require("private-next-pages/event/webinar/ai-security/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/webinar/ai-security"])
      });
    }
  